export const CustomBlock = ({ name, description = "", content }) => {
  return (
    <div className="row mb-3">
      <div className="col-12">
        <div className="adminPanel">
          {name && <h3 className="adminSectionTitle">{name}</h3>}
          {description !== "" && <div className="inputDescription">{description}</div>}
          {content}
        </div>
      </div>
    </div>
  );
};
